'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getSessionSaga;

var _effects = require('redux-saga/effects');

var _cookiesJs = require('cookies-js');

var _cookiesJs2 = _interopRequireDefault(_cookiesJs);

var _selectSession = require('../../selectors/context/selectSession');

var _setSessionSaga = require('./setSessionSaga');

var _setSessionSaga2 = _interopRequireDefault(_setSessionSaga);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(getSessionSaga);

function getSessionSaga() {
    var session, jsonCookie, cookie, culture;
    return regeneratorRuntime.wrap(function getSessionSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.select)((0, _selectSession.selectSession)());

                case 2:
                    session = _context.sent;

                    if (session) {
                        _context.next = 16;
                        break;
                    }

                    jsonCookie = _cookiesJs2.default.get('_metrix');
                    cookie = null;

                    if (jsonCookie) {
                        cookie = JSON.parse(jsonCookie);
                    }

                    if (!(cookie && cookie.session)) {
                        _context.next = 12;
                        break;
                    }

                    _context.next = 10;
                    return (0, _setSessionSaga2.default)({ payload: cookie.session });

                case 10:
                    _context.next = 16;
                    break;

                case 12:
                    culture = window.navigator.languages[0].substr(0, 2);

                    session = { culture: culture + '-CA' };
                    _context.next = 16;
                    return (0, _setSessionSaga2.default)({ payload: session });

                case 16:
                    return _context.abrupt('return', session);

                case 17:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}